import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import AnnualInterestRate from '../annual-interest-rate';

const AnnualInterestRateInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <AnnualInterestRate
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default AnnualInterestRateInputWithAnalytics;
